export default "__VITE_ASSET__CPoOp1tD__"